export default class CameraController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} Notification
	 */
	constructor(
		$element,
		$timeout,
		$translate,
		Notification,
	) {
		this.$element = $element;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.Notification = Notification;

		/** @type {?Function} */
		this.cancel = null;

		/** @type {?Function} */
		this.submit = null;

		/** @type {any} */
		this.video = {};

		/** @type {any} */
		this.canvas = undefined;

		/** @type {any} */
		this.context = undefined;

		this.mimeTypeVideo = undefined;
		this.mediaRecorder = undefined;

		/** @type {any[]} */
		this.recordedChunks = [];

		this.btnRecVideoDisabled = true;
		this.btnSubmitDisabled = true;
		this.showVideoControls = false;
		this.recording = false;
		this.file = null;
		this.src = {
			video: '',
			image: null,
		};
	}

	/**
	 * @param {any} error
	 */
	errorMissingCamera(error) {
		console.error(error);
		this.Notification.error({
			title:     this.$translate.instant('error.title'),
			message:   this.$translate.instant('error.missing-camera'),
		});
		if (typeof this.cancel === 'function') {
			this.cancel();
		}
	}

	/**
	 * @param {any} event
	 */
	handleDataAvailable(event) {
		if (event.data.size > 0) {
			this.recordedChunks.push(event.data);
		}
	}

	recVideo() {
		this.recordedChunks.length = 0;
		this.showVideoControls = false;

		if (this.video.srcObject.active) {
			this.src.image = null;
			// noinspection JSUnresolvedFunction
			this.mediaRecorder = new window.MediaRecorder(this.video.srcObject, { mimeType: this.mimeTypeVideo });
			this.mediaRecorder.ondataavailable = this.handleDataAvailable;
			this.mediaRecorder.start();
			this.recording = true;
			this.btnSubmitDisabled = true;
		}
		else {
			this.src.image = null;
			this.btnSubmitDisabled = true;
			navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
				this.video.srcObject = stream;
				return this.video.play();
			}).catch(error => this.errorMissingCamera(error));
		}
	}

	stopVideo() {
		this.mediaRecorder?.stop();
		this.video.srcObject.getTracks()[0].stop();
		this.recording = false;
		this.$timeout(() => {
			const superBuffer = new Blob(this.recordedChunks);
			this.src.video = window.URL.createObjectURL(superBuffer);
			this.file = new window.File(
				this.recordedChunks,
				`${new Date().toISOString().replace(/\D+/g, '')}.webm`,
				{ type: 'video/webm' },
			);

			this.showVideoControls = true;
			this.btnSubmitDisabled = false;
			// this.$scope.$apply();
		});
	}

	submitFile() {
		if (typeof this.submit === 'function') {
			this.submit({ file: this.file });
		}
		else if (typeof this.cancel === 'function') {
			this.cancel();
		}
	}

	takePic() {
		this.src.video = '';
		this.showVideoControls = false;

		if (this.video.srcObject.active) {
			this.context.drawImage(this.video, 0, 0, 1280, 960);

			const adata = this.canvas.toDataURL('image/jpeg').split(',');
			const byteString = atob(adata[1]);
			const ab = new ArrayBuffer(byteString.length);
			const ia = new Uint8Array(ab);

			for (let index = 0; index < byteString.length; index++) {
				const code = byteString.codePointAt(index);
				if (code !== undefined) {
					ia[index] = code;
				}
			}

			this.file = new window.File(
				[ab],
				`${new Date().toISOString().replace(/\D+/g, '')}.jpg`,
				{ type: adata[0].split(':')[1].split(';')[0] },
			);
			this.video.srcObject.getTracks()[0].stop();
			this.src.image = adata.join(',');
			this.btnSubmitDisabled = false;
		}
		else {
			this.src.image = null;
			this.btnSubmitDisabled = true;
			navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
				this.video.srcObject = stream;
				return this.video.play();
			}).catch(error => this.errorMissingCamera(error));
		}
	}

	$onDestroy() {
		if (this.video?.srcObject) {
			this.video.srcObject.getTracks()[0].stop();
		}
	}

	$onInit() {
		const mimetypesToCheck = [
			'video/webm;codecs=h264',
			'video/webm;codecs=vp9',
			'video/webm;codecs=vp8',
		];

		// Grab elements, create settings, etc.
		this.video = this.$element.find('video').get(0);
		this.canvas = this.$element.find('canvas').get(0);
		this.context = this.canvas.getContext('2d');

		this.$timeout(() => {
			if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
				for (const mimetype in mimetypesToCheck) {
					if (!this.mimeTypeVideo && window.MediaRecorder.isTypeSupported(mimetype)) {
						this.mimeTypeVideo = mimetype;
					}
				}

				if (this.mimeTypeVideo) {
					this.btnRecVideoDisabled = false;
				}

				navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
					this.video.srcObject = stream;
					return this.video.play();
				}).catch(error => this.errorMissingCamera(error));
			}
		});
	}
}
